import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const notesServiceName = 'notes';
export const serviceEventType = (entity, eventName) => eventType(notesServiceName, entity, eventName);
export const NotesServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: serviceEventType(),
}));
